// A strike tone plays on every hour, so it has to stay short. Enforced in the
// studio before upload and again by klydo-api on /uploads/upload-strike.
export const MAX_STRIKE_DURATION_SECONDS = 3;
